import { render, staticRenderFns } from "./RightButtons.vue?vue&type=template&id=6967f3f0&scoped=true&"
import script from "./RightButtons.vue?vue&type=script&lang=js&"
export * from "./RightButtons.vue?vue&type=script&lang=js&"
import style0 from "./RightButtons.vue?vue&type=style&index=0&id=6967f3f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967f3f0",
  null
  
)

export default component.exports